module.exports = __webpack_public_path__ + "static/media/vegitables_49.58bd867d.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_49.csv
// module id = 634
// module chunks = 0